const essayPageConfig = {
    routePath: '/essay-questions',
    canonicalUrl: 'https://codingwithghonaim.com/essay-questions',
    title: 'مش عارف تحل أسئلة المقالي؟ طريقة الحل خطوة بخطوة | Coding With Ghonaim',
    description: 'مش عارف تحل المقالي؟ اتعلم طريقة READ ثم IDENTIFY ثم RECALL ثم ORGANIZE ثم WRITE ثم CHECK للطلاب العربي واللغات في Programming & AI.',
    datePublished: '2026-10-23',
    dateModified: '2026-10-23',
    lastReviewed: '2026-10-23',
    authorName: 'م/ محمد غنيم',
    authorUrl: '/about',
    logoUrl: '/img/logo.png',
    mindmapImage: '/images/seo/essay-questions/how-to-solve-essay-questions-coding-with-ghonaim-arabic-english.webp',
    mindmapSource: '/images/seo/essay-questions/how-to-solve-essay-questions-coding-with-ghonaim-arabic-english.png',
    socialImageUrl: '/images/seo/essay-questions/how-to-solve-essay-questions-coding-with-ghonaim-og.jpg',
    mindmapAlt: 'إزاي تحل أسئلة المقالي خطوة بخطوة للطلاب العربي واللغات — Coding With Ghonaim',
    youtubeUrl: 'https://youtu.be/2NZVm6I1-2s',
    youtubeEmbedUrl: 'https://www.youtube.com/embed/2NZVm6I1-2s?rel=0&modestbranding=1',
    youtubeThumbnail: 'https://i.ytimg.com/vi/2NZVm6I1-2s/hqdefault.jpg',
    videoUploadDate: '',
    videoDuration: '',
    videoChapters: [],
    pdfUrl: '/downloads/how-to-solve-essay-questions-coding-with-ghonaim.pdf',
    ghonaimHubUrl: '',
    askGhonaimUrl: '',
    grade10Route: '/grade-10',
    grade11Route: '/grade-11',
    grade10CourseRoute: '/courses/10',
    grade11CourseRoute: '/courses/9',
    grade10CurriculumRoute: '/grade-10-programming-ai-curriculum',
    grade11CurriculumRoute: '/grade-11-programming-ai-curriculum',
    allLinksUrl: 'https://start.codingwithghonaim.com/links',
    whatsappChannelUrl: 'https://whatsapp.com/channel/0029Vb6z3DX3wtb8iKfkA21K',
    telegramUrl: 'https://t.me/codingwithghonaim',
    iosAppUrl: 'https://apps.apple.com/eg/app/codingwithghonaim/id6778895200',
    androidAppUrl: 'https://play.google.com/store/apps/details?id=com.codingwithghonaim.app',
};

const methodSteps = [
    { number: 1, en: 'READ', ar: 'اقرأ', icon: 'BookOpen', text: 'اقرأ السؤال كاملًا: بيتكلم عن إيه وطالب منك إيه؟', example: 'Why is MFA more secure than using only a password?', focus: 'MFA · WHY' },
    { number: 2, en: 'IDENTIFY', ar: 'حدّد', icon: 'ScanSearch', text: 'حدّد الـCommand Word ونوع الإجابة المطلوبة.', example: 'Why → سبب مباشر يبدأ بـ Because أو يوضح السبب.', focus: 'COMMAND WORD' },
    { number: 3, en: 'RECALL', ar: 'افتكر', icon: 'Brain', text: 'افتكر الـKeywords بدل ما تحاول تحفظ Model Answer كامل.', example: 'different factors · password · second factor', focus: 'KEYWORDS' },
    { number: 4, en: 'ORGANIZE', ar: 'رتّب', icon: 'ListOrdered', text: 'رتّب عناصر الإجابة في شكل مناسب للسؤال.', example: 'Because → Reason أو A ↔ B أو Step 1 → Step 2', focus: 'ANSWER SHAPE' },
    { number: 5, en: 'WRITE', ar: 'اكتب', icon: 'PencilLine', text: 'اكتب المعنى العلمي مباشرة بجمل قصيرة وواضحة.', example: 'MFA is safer because it requires more than one independent factor.', focus: 'SHORT · CLEAR · CORRECT' },
    { number: 6, en: 'CHECK', ar: 'راجع', icon: 'CheckCircle2', text: 'راجع إنك جاوبت كل المطلوب واستخدمت المصطلحات الصحيحة.', example: 'السؤال طلب TWO؟ لازم تكون كتبت نقطتين مختلفتين.', focus: 'ALL PARTS' },
];

const commandWords = [
    ['Define', 'عرّف', 'اكتب معنى المصطلح بدقة', 'Term → Meaning', 'Define authentication.'],
    ['What is', 'ما هو', 'تعريف مباشر للفكرة', 'X is…', 'What is encryption?'],
    ['Why', 'لماذا', 'اذكر السبب العلمي', 'Because → Reason', 'Why is MFA safer?'],
    ['Give a reason', 'علّل', 'سبب واحد واضح أو العدد المطلوب', 'Reason', 'Give a reason for using encryption.'],
    ['Explain', 'اشرح', 'الفكرة وكيف أو لماذا تعمل', 'Idea → Explanation', 'Explain how MFA protects an account.'],
    ['Compare', 'قارن', 'اكتب طرفي المقارنة على نفس الأساس', 'A ↔ B', 'Compare encryption and digital signatures.'],
    ['Differentiate', 'فرّق', 'وضح الاختلاف الأساسي بين مفهومين', 'A differs from B in…', 'Differentiate authentication and authorization.'],
    ['Mention', 'اذكر', 'اكتب النقاط المطلوبة فقط', 'Point 1 · Point 2', 'Mention two authentication factors.'],
    ['List', 'عدّد', 'قائمة بعدد العناصر المطلوبة', '1 / 2 / 3', 'List three security controls.'],
    ['Describe', 'صف', 'اشرح خطوات أو خصائص شيء', 'Feature / Process', 'Describe the login process.'],
    ['Suggest', 'اقترح', 'إجراء مناسب مع سبب مختصر', 'Action + Reason', 'Suggest a way to secure the account.'],
    ['What happens if', 'ماذا يحدث إذا', 'اكتب النتيجة المترتبة', 'Condition → Result', 'What happens if a key is exposed?'],
    ['Calculate', 'احسب', 'القانون ثم التعويض والنتيجة', 'Formula → Substitution → Result', 'Calculate the required storage.'],
    ['Scenario', 'موقف / سيناريو', 'استخرج الدليل وحدد المفهوم ثم جاوب', 'Clues → Concept → Answer', 'A student receives a suspicious login link…'],
];

const workedExamples = [
    {
        type: 'Definition',
        question: 'What is authentication?',
        identify: 'Define / What is → Definition',
        keywords: ['verify', 'identity', 'user'],
        answer: 'Authentication is the process of verifying the identity of a user.',
        check: 'تعريف مباشر ويحتوي verify + identity.',
    },
    {
        type: 'Why',
        question: 'Why is MFA more secure than using only a password?',
        identify: 'Why → Reason',
        keywords: ['different factors', 'password', 'second factor'],
        answer: 'MFA is more secure because it requires two or more different factors, so a stolen password alone is not enough to access the account.',
        check: 'ذكر السبب والنتيجة ولم يكتفِ بكلمة more secure.',
    },
    {
        type: 'Compare',
        question: 'Compare Encryption and Digital Signature.',
        identify: 'Compare → Two sides',
        keywords: ['confidentiality', 'sender', 'integrity', 'authenticity'],
        answer: 'Encryption protects data confidentiality, while a digital signature helps verify the sender and the integrity and authenticity of the message.',
        check: 'قارن المفهومين على أساس الوظيفة.',
    },
    {
        type: 'Scenario',
        question: 'A student receives a link asking for a password and OTP. What should the student do and why?',
        identify: 'Scenario + Suggest → Action + Reason',
        keywords: ['phishing', 'do not share OTP', 'official channel'],
        answer: 'The student should not open the link or share the password or OTP, and should verify the message through the official channel because it may be a phishing attempt.',
        check: 'استخدم clues وحدد الخطر وقدم التصرف والسبب.',
    },
    {
        type: 'عربي',
        question: 'لماذا تعد المصادقة متعددة العوامل أكثر أمانًا؟',
        identify: 'لماذا → سبب علمي',
        keywords: ['أكثر من عامل', 'كلمة المرور', 'عامل إضافي'],
        answer: 'لأنها تتطلب أكثر من عامل مستقل للتحقق من الهوية، لذلك لا تكفي سرقة كلمة المرور وحدها للدخول إلى الحساب.',
        check: 'إجابة قصيرة، مباشرة، وتحتوي المصطلحات المطلوبة.',
    },
];

const transformations = [
    {
        question: 'What is the purpose of a Digital Certificate?',
        weak: 'It is used for security.',
        why: 'إجابة عامة ولا توضح ما الذي يتم التحقق منه.',
        strong: 'A digital certificate helps verify that a public key belongs to its claimed owner or genuine communication partner.',
    },
    {
        question: 'Why is encryption important?',
        weak: 'Because it protects information.',
        why: 'لا توضح نوع الحماية.',
        strong: 'Encryption protects data confidentiality by making it unreadable without the correct key.',
    },
    {
        question: 'عرّف المصادقة.',
        weak: 'المصادقة مهمة جدًا في الأمان.',
        why: 'تتكلم عن الأهمية بدل التعريف.',
        strong: 'المصادقة هي عملية التحقق من هوية المستخدم.',
    },
    {
        question: 'Mention two benefits of strong passwords.',
        weak: 'They are better and safer.',
        why: 'لم يذكر فائدتين منفصلتين.',
        strong: 'They reduce the chance of guessing attacks and make unauthorized access more difficult.',
    },
];

const platformFeatures = [
    { number: '1', title: 'أسئلة كتير عشان تتدرب وتغلط وتتعلم', icon: 'Repeat2', text: 'التدريب يحول الفهم إلى Skill: سؤال، إجابة، غلطة، فهم السبب، ثم محاولة جديدة.', note: 'الغلط في التدريب أحسن من إن أول مرة تواجه الغلطة تكون في الامتحان.', urlKey: 'ghonaimHubUrl', event: 'essay_hub_cta' },
    { number: '2', title: 'بنحل أسئلة الوزارة والـAssessments', icon: 'Landmark', text: 'عشان تعرف أفكار الأسئلة وطرق صياغتها، تفهم الـCommand Words، وتشوف شكل عناصر الإجابة المتوقعة بدون ادعاء توقع أسئلة الامتحان.' },
    { number: '3', title: 'كل Concept لازم تستخدمه', icon: 'Workflow', text: 'بعد الشرح يأتي سؤال ثم إجابة وFeedback، فلا يظل المفهوم مجرد فيديو شاهدته.' },
    { number: '4', title: 'في المراجعات بنربط الأفكار ببعض', icon: 'Network', text: 'Encryption وCertificate وMFA وSignature يمكن أن يجتمعوا في Secure Online Service Scenario واحد.' },
    { number: '5', title: 'لو وقفت في سؤال… اسأل Ask Ghonaim', icon: 'MessageCircleQuestion', text: 'افهم السؤال، حدد المصطلحات، شوف الإجابة المتوافقة مع الكتاب، ثم ارجع وحاول بنفسك.', note: 'استخدمه عشان تفهم… مش عشان تنسخ.', urlKey: 'askGhonaimUrl', event: 'ask_ghonaim_cta' },
];

const programmingStats = {
    grade11: [
        { value: '2,400+', labelAr: 'سؤال وتدريب خلال أول شابترين فقط', labelEn: 'practice questions through Chapter 2 only', verified: true },
        { value: '9', labelAr: 'محاضرات حتى الآن: 7 دروس أساسية + مراجعتين', labelEn: 'lectures so far: 7 core lessons + 2 reviews', verified: true },
        { value: '290+', labelAr: 'سؤال وتدريب تقريبًا مع كل درس أساسي', labelEn: 'practice items around each core lesson', verified: true },
    ],
    grade11Note: 'الرقم موزع بين الشرح، Homework، Ghonaim Hub، Quizzes، أسئلة الوزارة والتقييمات، والمقالي — ومش شامل الامتحانات الشاملة والمسابقات.',
    grade10: [],
};

const coursePowers = [
    ['Curriculum-first', 'شرح مبني على المنهج ومصطلحاته.', 'BookOpenCheck'],
    ['Arabic + Languages', 'دعم للمسارين باللغة والمصطلحات المناسبة.', 'Languages'],
    ['Questions, not just videos', 'شرح + تطبيق + واجب + Quiz + مراجعة.', 'CircleHelp'],
    ['Ministry questions', 'حل أفكار الوزارة والتقييمات وطرق صياغتها.', 'Landmark'],
    ['Ghonaim Hub', 'بيئة تدريب تتجاوز وقت المحاضرة.', 'PanelsTopLeft'],
    ['Ask Ghonaim', 'مساعدة مباشرة عند التوقف في سؤال.', 'MessageCircleQuestion'],
    ['Essay Skills', 'تدريب Define وWhy وExplain وCompare وScenario.', 'FileText'],
    ['Continuous Revision', 'ربط المفاهيم القديمة والجديدة باستمرار.', 'RefreshCw'],
];

const studentJourney = [
    ['WATCH', 'افهم الـConcept'],
    ['SOLVE', 'حل أسئلة المحاضرة'],
    ['HOMEWORK', 'تدرب بنفسك'],
    ['GHONAIM HUB', 'أسئلة أكتر'],
    ['REVIEW MISTAKES', 'افهم غلطك'],
    ['REVISION', 'اربط الأفكار'],
    ['QUIZ / EXAM', 'قِس تقدمك'],
];

const faqGroups = [
    {
        title: 'حل أسئلة المقالي',
        items: [
            ['ليه بعرف أحل MCQ ومبعرفش مقالي؟', 'لأن الـMCQ يعتمد غالبًا على Recognition: الإجابة أو دليل عليها موجود في الاختيارات. المقالي يحتاج Recall ثم تنظيم الفكرة والتعبير عنها، ودي Skill تتحسن بالتدريب.'],
            ['هل إجابة المقالي لازم تكون طويلة؟', 'لا. المطلوب إجابة كاملة وواضحة وتجاوب السؤال مباشرة. القاعدة الأفضل: Short + Clear + Correct.'],
            ['أعمل إيه لو مش فاكر الـModel Answer؟', 'ارجع للمفهوم والـKeywords وعناصر الإجابة. لا تخترع معلومة ولا تحاول تذكر ترتيب الجمل حرفيًا.'],
            ['إزاي أعرف السؤال عايز مني إيه؟', 'حدد الـCommand Word أولًا: Define للتعريف، Why للسبب، Explain للشرح، Compare للطرفين، وMention لعدد النقاط المطلوبة.'],
            ['الفرق بين Explain وDefine؟', 'Define يطلب معنى المصطلح مباشرة، بينما Explain يحتاج الفكرة مع توضيح كيف أو لماذا تحدث.'],
            ['إزاي أحل Compare؟', 'حدد أساس المقارنة، ثم اكتب الطرف الأول والطرف الثاني على نفس الأساس باستخدام while أو بينما.'],
            ['لو السؤال قال Mention two؟', 'اكتب نقطتين مختلفتين وواضحتين فقط. نقطة واحدة طويلة لا تعوض غياب النقطة الثانية.'],
            ['أحفظ الـModel Answers؟', 'افهم عناصر الإجابة والمصطلحات الأساسية بدل حفظ ترتيب الجمل؛ ده يساعدك مع أي صياغة جديدة للسؤال.'],
            ['لو إجابتي مختلفة عن الـModel Answer تبقى غلط؟', 'قد تكون صحيحة إذا نقلت المعنى العلمي المطلوب واحتوت العناصر والمصطلحات الأساسية، مع الالتزام بقواعد التصحيح الخاصة بالسؤال.'],
        ],
    },
    {
        title: 'العربي واللغات',
        items: [
            ['أعمل إيه لو مش بعرف أكتب إنجليزي؟', 'استخدم English بسيطًا، جملًا قصيرة، ومصطلحات المنهج. المعنى العلمي الصحيح أهم من الجملة المعقدة.'],
            ['أكتب الإجابة العربي إزاي؟', 'استخدم المصطلح العلمي، جاوب مباشرة، وتجنب المقدمات العامة وتكرار نص السؤال.'],
            ['هل الطريقة تختلف بين عربي وLanguages؟', 'لا. اللغة تتغير لكن طريقة التفكير ثابتة: Read, Identify, Recall, Organize, Write, Check.'],
            ['هل لازم أترجم السؤال كلمة بكلمة؟', 'لا. حدد الـCommand Word والمفهوم والمطلوب أولًا، ثم صغ الإجابة باللغة التي تدرس بها.'],
        ],
    },
    {
        title: 'Programming & AI',
        items: [
            ['إزاي أحل Scenario طويل؟', 'اقرأ المطلوب، علم على الـclues، تجاهل التفاصيل غير المهمة، حدد الـconcept والـcommand word، ثم جاوب المطلوب فقط.'],
            ['إزاي أبدأ أذاكر المقالي؟', 'بعد كل 10 أسئلة MCQ اختَر سؤالين، اخفِ الاختيارات، استرجع الـKeywords، واكتب الإجابة ثم راجعها.'],
            ['إيه أهم حاجة في إجابة البرمجة؟', 'المعنى العلمي ومصطلحات المنهج، مع توضيح العلاقة المطلوبة مثل سبب أو مقارنة أو نتيجة.'],
            ['هل السؤال المقالي موضوع تعبير؟', 'لا. الهدف ليس ملء السطور؛ الهدف كتابة عناصر الإجابة المطلوبة بوضوح ودقة.'],
        ],
    },
    {
        title: 'Coding With Ghonaim',
        items: [
            ['هل Coding With Ghonaim متاح للعربي واللغات؟', 'نعم، الصفحة والكورسات تدعم طلاب العربي واللغات باستخدام مصطلحات وصياغة المنهج المناسبة لكل مسار.'],
            ['هل التدريب على المقالي موجود داخل الكورس؟', 'النظام يعتمد على أسئلة المحاضرات والواجبات والاختبارات والمراجعات وأسئلة الوزارة والتقييمات، بما فيها مهارات الإجابة المقالي.'],
            ['هل بيتم حل أسئلة الوزارة والتقييمات؟', 'نعم بهدف فهم أفكار الأسئلة وطرق الصياغة وشكل الإجابة، بدون ادعاء معرفة أسئلة امتحان قادم.'],
            ['هل فيه أسئلة بعد كل محاضرة؟', 'النظام التعليمي يربط الشرح بالتطبيق والأسئلة والواجب والـQuiz حتى يستخدم الطالب كل Concept.'],
            ['هل فيه مراجعات؟', 'نعم، والمراجعات تساعد الطالب يربط المفاهيم القديمة والجديدة ويحل أسئلة تجمع أكثر من فكرة.'],
            ['هل المنصة للصف الأول ولا الثاني الثانوي؟', 'Coding With Ghonaim يقدم Programming & AI لطلاب Grade 10 وGrade 11، عربي وLanguages.'],
        ],
    },
    {
        title: 'Ghonaim Hub + Ask Ghonaim',
        items: [
            ['إيه هو Ghonaim Hub؟', 'بيئة تدريب إضافية مرتبطة بالتجربة التعليمية، تساعد الطالب يحل أسئلة أكثر، يراجع أخطاءه، ويحاول مرة أخرى.'],
            ['إيه هو Ask Ghonaim؟', 'مساعدة تعليمية عند التوقف في سؤال لفهم المطلوب والمصطلحات والإجابة المتوافقة مع الكتاب، ثم العودة للمحاولة.'],
            ['هل Ask Ghonaim بيحل بدل الطالب؟', 'الهدف إنك تستخدمه للفهم وتحديد الـKeywords ثم تحاول بنفسك، وليس لنسخ الإجابة.'],
        ],
    },
];

const staticAnswerHtml = `
<article dir="rtl" lang="ar">
  <h1>مش عارف تحل أسئلة المقالي؟</h1>
  <p>دي مش مشكلة في فهمك… غالبًا محتاج طريقة للحل.</p>
  <h2>إزاي أحل السؤال المقالي؟</h2>
  <p><strong>حل السؤال المقالي في 6 خطوات:</strong> اقرأ السؤال كاملًا، حدد نوعه والمطلوب، افتكر الكلمات الأساسية، رتب عناصر الإجابة، اكتب إجابة قصيرة وواضحة وصحيحة، ثم راجع أنك جاوبت كل المطلوب.</p>
  <ol><li>اقرأ — READ</li><li>حدّد — IDENTIFY</li><li>افتكر — RECALL</li><li>رتّب — ORGANIZE</li><li>اكتب — WRITE</li><li>راجع — CHECK</li></ol>
  <h2>ليه بحل MCQ ومبعرفش أحل مقالي؟</h2>
  <p>في الـMCQ يعتمد الطالب غالبًا على Recognition، بينما يحتاج السؤال المقالي إلى Recall ثم تنظيم الإجابة وكتابتها. أنت ممكن تكون فاهم المعلومة فعلًا، لكنك محتاج تتدرب إزاي تطلعها من دماغك وتكتبها.</p>
  <h2>السؤال المقالي مش موضوع تعبير</h2>
  <p>الهدف ليس ملء السطور. الهدف أن تحتوي الإجابة على العناصر المطلوبة ومصطلحات المنهج: Short + Clear + Correct.</p>
  <h2>الطريقة واحدة سواء أنت عربي أو Languages</h2>
  <p>اللغة تتغير، لكن طريقة التفكير لا تتغير: READ → IDENTIFY → RECALL → ORGANIZE → WRITE → CHECK.</p>
</article>`;

module.exports = {
    essayPageConfig,
    methodSteps,
    commandWords,
    workedExamples,
    transformations,
    platformFeatures,
    programmingStats,
    coursePowers,
    studentJourney,
    faqGroups,
    staticAnswerHtml,
};
